import React from 'react'
import useIconSize from '../icon-size'
import IconPropTypes from '../IconPropTypes'

function IconCoin({ size = undefined, ...props }) {
  const sizeValue = useIconSize(size)
  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.096 10.735c.074-.386.389-.626.703-.535.945.273 1.72.726 2.272 1.283.54.546.929 1.263.929 2.057 0 1.374-.966 2.429-2.1 3.096-1.186.697-2.788 1.124-4.533 1.124-1.613 0-3.1-.365-4.25-.967-1.113-.582-2.056-1.47-2.315-2.632-.086-.383.098-.778.409-.883.311-.105.633.12.718.503.113.507.624 1.155 1.645 1.69.985.515 2.313.851 3.793.851 1.605 0 3.028-.394 4.028-.983 1.053-.619 1.436-1.314 1.436-1.799 0-.199-.107-.548-.502-.946-.384-.388-.984-.76-1.798-.995-.314-.09-.509-.478-.435-.864z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.576 6.296C5.524 6.851 5.17 7.484 5.17 7.945c0 .484.381 1.177 1.43 1.795.996.587 2.413.981 4.01.981 1.599 0 3.016-.394 4.012-.981 1.048-.618 1.43-1.311 1.43-1.795 0-.461-.356-1.094-1.408-1.649-.998-.526-2.421-.859-4.033-.859-1.612 0-3.036.333-4.034.86zm-.46-1.32C7.295 4.353 8.884 4 10.61 4c1.725 0 3.314.353 4.494.976 1.127.594 2.115 1.575 2.115 2.969 0 1.371-.963 2.425-2.093 3.091-1.182.697-2.777 1.123-4.516 1.123-1.74 0-3.335-.426-4.517-1.123C4.963 10.37 4 9.316 4 7.945c0-1.394.989-2.375 2.115-2.97zm1.249 7.986c.323 0 .585.321.585.718 0 .474.377 1.161 1.427 1.775.997.583 2.415.974 4.013.974 1.6 0 3.017-.391 4.014-.974 1.05-.614 1.427-1.301 1.427-1.775 0-.397.262-.718.585-.718.322 0 .584.321.584.718v2.24c0 1.389-.974 2.406-2.105 3.036C16.714 19.614 15.122 20 13.39 20c-1.73 0-3.323-.386-4.505-1.044-1.13-.63-2.104-1.647-2.104-3.035v-2.24c0-.398.262-.72.584-.72zm.6 3.13c.079.459.475 1.038 1.403 1.555.996.555 2.417.916 4.022.916 1.606 0 3.026-.361 4.023-.916.928-.517 1.324-1.096 1.403-1.554-.278.25-.587.471-.91.66-1.182.69-2.777 1.113-4.515 1.113-1.739 0-3.334-.422-4.515-1.113a5.513 5.513 0 01-.911-.66z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.596 9.854c.997.583 2.415.974 4.014.974 1.598 0 3.016-.391 4.013-.974 1.05-.614 1.427-1.301 1.427-1.775h1.169v2.24c0 1.389-.974 2.406-2.104 3.036-1.182.658-2.774 1.044-4.505 1.044-1.732 0-3.324-.386-4.506-1.044C4.974 12.725 4 11.708 4 10.32V8.08h1.169c0 .473.378 1.16 1.427 1.774zm-1.412.638c.079.458.475 1.037 1.403 1.553.997.556 2.417.917 4.023.917 1.605 0 3.026-.361 4.022-.916.928-.517 1.324-1.096 1.403-1.554-.277.25-.587.471-.91.66-1.182.69-2.777 1.113-4.515 1.113-1.739 0-3.334-.422-4.515-1.113a5.513 5.513 0 01-.911-.66z"
        clipRule="evenodd"
      />
    </svg>
  )
}

IconCoin.propTypes = IconPropTypes
export default IconCoin
